import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import deepBind from 'deep-bind-decorator';

import BaseComponent from 'base-component';
import BaseContentModel from 'base-contentmodel';

import DocumentBuilderComponent from './component';

export class DocumentBuilderItemContentModel extends BaseContentModel {
  static _slots = {
    content: "", // the content of this item
  };

  static get _defaults(){
    return {
      content: "Item Content 1",
      sourceIndex: 0,
      targetIndex: 1,
      inTarget: false,
      originalIndex: 1
    }
  }

  /* @slot */ @observable 
  content = "Item Content";

  @observable
  sourceIndex = 0;

  @observable
  targetIndex = 0;

  @observable
  inTarget = false;

  @observable
  originalIndex = 0;
}

export class DocumentBuilderContentModel extends BaseContentModel {
  // the ContentModel classes contain the customizable "slots" that content creators will be filling in
  // presently these are defined via static _slots, but will be applied via @slot sugar
  // see the list below for examples of the slot types, and the editor input created for each:
  static _slots = {
    activityTitle: "",
    preActivityText: "",
    sourceTitle: "",
    targetTitle: "",
    randomizeItems: true,
    postActivityText: "",
    items: [DocumentBuilderItemContentModel],
  };

  static get _defaults(){
    return {
      sourceTitle: "Source Items",
      targetTitle: "Selected Items",
      randomize: true,
      items: [
        new DocumentBuilderItemContentModel(DocumentBuilderItemContentModel._defaults)
      ]
    }
  }

  // define the default Component (Sim) view of this component
  Component = DocumentBuilderComponent

  @observable
  /* @slot */ activityTitle = "Activity Title (Optional)";

  @observable
  /* @slot */ preActivityText = "Pre Activity Text (Optional)";

  @observable
  /* @slot */ sourceTitle = "Available Items";

  @observable
  /* @slot */ targetTitle = "Selected Items";

  @observable
  /* @slot */ postActivityText = "Post Activity Text (Optional)";

  @observable
  /* @slot */ randomizeItems = true;

  @observable.shallow
  /* @slot([DocumentBuilderItemContentModel]) */ items = [];

  // this will create a user input whose variable name is the contentmodel id appended with 'variableName'
  @observable @deepBind 

  /* @input("variableName") userInput = "default value" */ 
  userInput = {
    get variable(){ return `G:${this.id}_${this.userInput.suffix}:G`; },
    suffix: "variableName",
    value: ""
  }
  
  @observable isSubmitted = false;
}
export default DocumentBuilderContentModel


// WEBPACK FOOTER //
// ./app_modules/document-builder-activity/src/contentmodel.js